import { getCsrfToken } from 'query';
import {
  CURRENT_REVIEWER_ROUTE,
  tokenizeRoute,
  UPDATE_REVIEWER_PROFILE_ROUTE,
} from 'query/routes';
import type { Reviewer } from 'types/DataExtraction';

export const getCurrentReviewer = async (): Promise<Reviewer> => {
  const response = await fetch(CURRENT_REVIEWER_ROUTE, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  return await response.json();
};

export const updateProfile = async (firstName: string, lastName: string) => {
  const url = tokenizeRoute(UPDATE_REVIEWER_PROFILE_ROUTE, {});

  const formData = new FormData();
  formData.append('reviewer[first_name]', firstName);
  formData.append('reviewer[last_name]', lastName);

  return fetch(url.toString(), {
    method: 'PATCH',
    body: formData,
    headers: {
      'X-CSRF-Token': getCsrfToken(),
    },
    redirect: 'manual',
  });
};
